import LoadingButton from "@mui/lab/LoadingButton"
import Popover from "@mui/material/Popover"
import TextField from "@mui/material/TextField"
import { useState } from "react"

import Row from "../../../common/components/Row"

const MIN_PROMPT_LEN = 30

export default function GenerateInboxTemplatePromptPopover({
  anchorElem,
  onClose,
  generateFn,
}) {
  const [prompt, setPrompt] = useState("")
  const [promptError, setPromptError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  function handleSubmit() {
    setIsLoading(true)
    generateFn(prompt)
      .then(({ data }) => {
        setPrompt("")
        setPromptError(null)
        onClose({ ...data, prompt })
      })
      .catch(() =>
        setPromptError("Couldn't generate that template. Please try again.")
      )
      .finally(() => setIsLoading(false))
  }

  return (
    <Popover
      open={!!anchorElem}
      anchorEl={anchorElem}
      onClose={() => onClose()}
      anchorOrigin={{ horizontal: "center", vertical: "center" }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
    >
      <Row sx={{ gap: 1, p: 1, pt: 2 }}>
        <TextField
          label="Prompt"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          error={!!promptError}
          helperText={
            promptError || `Type at least ${MIN_PROMPT_LEN} characters`
          }
          multiline
          rows={2}
          maxRows={2}
          sx={{ width: "20em" }}
        />
        <LoadingButton
          variant="contained"
          loading={isLoading}
          disabled={prompt.length < MIN_PROMPT_LEN}
          sx={{ height: "63px" }}
          onClick={handleSubmit}
        >
          Generate
        </LoadingButton>
      </Row>
    </Popover>
  )
}
